import PersonaDelete from './PersonaDelete'
export {PersonaDelete}
export default PersonaDelete
